export default __webpack_public_path__ + "static/media/banner.4db99e35.jpg";